import { Theme } from 'morpheus-ui';
import { tv } from 'tailwind-variants';

const borderWidthKeys = Object.keys(Theme.borderWidth);
export const buttonCardClasses = tv(
  {
    base: 'flex rounded-md bg-color-lightest border-mono-color-lighter border-thin hover:cursor-pointer',
    variants: {
      iconPosition: {
        top: 'flex-col',
        left: 'flex-row',
      },
      size: {
        sm: 'gap-md p-4',
        md: 'gap-xl p-5',
      },
      orientation: {
        vertical: 'flex-col',
        horizontal: 'flex-row',
      },
    },
  },
  {
    twMergeConfig: {
      theme: {
        borderWidth: borderWidthKeys,
      },
    },
  }
);
